import React, { useEffect, useState } from 'react'
// import Navbar from '../components/navbar'
import { Suspense } from 'react'
// import Sidebar from '../components/sidebar'
// import Footer from '../components/footer'
import useViewport from '../hooks/useViewPort'
import Sidebar from '../components/sidebar/sidebar';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import { useLocation } from 'react-router-dom';

const AuthLayout = ({ children }) => {
    const [wideContetnt, setWideContetnt] = useState(false);
    const [sidebarStatus, setSidebarStatus] = useState(true);
    const { pathname } = useLocation();
    const { width } = useViewport()
    useEffect(() => {
        if (width < 850) {
            setWideContetnt(true);
            setSidebarStatus(false);

        } else {
            setWideContetnt(false);
            setSidebarStatus(true);
        }
    }, [width])
    const handleSidebarClick = () => {
        setSidebarStatus(!sidebarStatus);
        setWideContetnt(!wideContetnt);
    } 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, [pathname]);
    return (
        <Suspense fallback={<div />}>
            <div className={`container ${(width < 850 || wideContetnt) && 'wide-content'} `} >
                <Suspense fallback={<div />}>
                    <Sidebar sidebarStatus={sidebarStatus} wideContetnt={wideContetnt} isSmallScreen={width < 850} />
                </Suspense>
                <div className={width < 850 || (wideContetnt) ? "page-wrapper wide-content" : "page-wrapper"}  >
                    {width < 850 && sidebarStatus &&
                        <div className="sidebar-overlay">
                        </div>
                    }
                    <Suspense fallback={<div />}>
                        <Navbar handleSidebarClick={handleSidebarClick} />
                    </Suspense>
                    <div className="page-content">
                        <div className="container-fluid">
                            <Suspense >{children}</Suspense>
                        </div>
                    </div>
                    <Suspense fallback={<div />}>
                        <Footer />
                    </Suspense>
                </div>
            </div >
        </Suspense >
    )
}

export default AuthLayout
